<template>
  <div id="product-case-type" :class="['casetype-selector']">
    <div
      v-show="hasMultipleFilteredCaseTypes"
      id="type-selector"
      :class="['image-select open image-select--notoggle']"
    >
      <div v-if="currentOption" class="casetype-selector__selected">
        <div v-if="false">
          <span class="casetype-selector__hint">
            {{ $t('product_form.choose_case_type') }}:
          </span>
          <b>{{ selectedName }}</b>
        </div>
        <span
          v-if="showCaseTypeShowMore"
          class="casetype-selector__info"
          @click="openShowMore"
        >
          <info-icon color="#929296" />
          <small style="color: #929296">{{
            $t('product_form.questions_about_cases')
          }}</small>
        </span>
      </div>
      <transition name="fade">
        <modal
          :open="caseTypeInfoModal"
          max-width="600"
          :full-screen="false"
          :fixed-btn="true"
          :show-footer="true"
          class="casetype-selector__info-modal"
          @close="closeShowMore"
        >
          <template v-slot:title>
            <b> {{ $t('product_form.select_casetype') }}</b>
          </template>
          <div class="casetype-selector__body">
            <ul class="casetype-info">
              <li
                v-for="case_type in caseTypeGroupsWithPrices"
                :key="case_type.id"
                :data-testid="`item-${case_type.id}`"
                :class="[
                  'casetype-info__item',
                  {
                    'casetype-info__item--selected': isSelected(case_type),
                  },
                ]"
                @click="selectOption(case_type)"
              >
                <a
                  href="#"
                  rel="nofollow"
                  :data-id="case_type.id"
                  @click.prevent
                >
                  <img
                    class="casetype-info__image"
                    :src="convertImagekit(case_type.image_url, 500)"
                    :alt="case_type.name"
                  />
                </a>
                <div class="casetype-info__name">
                  <transition name="fade">
                    <span v-if="isInStock(case_type)">
                      {{ formatPrice(case_type.price) }}
                    </span>
                  </transition>
                  <template v-if="isPreSale">
                    {{ $t('product_form.coming_soon') }}
                  </template>
                  <template v-else-if="!isInStock(case_type)">
                    {{ $t('product_form.sold_out') }}
                  </template>
                </div>
              </li>
            </ul>
            <div
              v-if="caseTypeDetailsParser(currentCaseTypeDetails, 'content')"
              class="casetype-info__description"
              v-html="caseTypeDetailsParser(currentCaseTypeDetails, 'content')"
            ></div>
          </div>
          <template v-slot:footer>
            <v-button block @click="closeShowMore(true)">
              {{ $t('product_form.select_casetype_check') }}
            </v-button>
          </template>
        </modal>
      </transition>
      <ul
        v-if="
          ['b', 'c'].includes(caseTypeUiTest) &&
          caseTypeDetailsParser(currentCaseTypeDetails, 'attributes')
        "
        :class="[
          'casetype-selector__attributes',
          `casetype-selector__attributes--ctui-${caseTypeUiTest}`,
          {
            'casetype-selector__attributes--mobile': isMobileFixedMockup,
          },
        ]"
      >
        <li
          v-for="attr in caseTypeDetailsParser(
            currentCaseTypeDetails,
            'attributes'
          )"
          :key="attr.title"
        >
          <div class="casetype-selector__attributes-title">
            <span>{{ attr.title }}: </span>
            <div
              :class="[
                { 'casetype-selector__attributes-fixed-title': !attr.percent },
              ]"
            >
              {{ attr.value }}
            </div>
          </div>
          <div
            v-if="attr.percent"
            class="casetype-selector__attributes-progress"
          >
            <div :style="`width: ${attr.percent}%`"></div>
          </div>
        </li>
      </ul>
      <div
        :class="[
          'casetype-selector__container',
          `casetype-selector__container--ctui-${caseTypeUiTest}`,
        ]"
      >
        <ul
          :class="[
            'casetype-selector__list',
            `casetype-selector__list--ctui-${caseTypeUiTest}`,
          ]"
        >
          <li
            v-for="case_type in filteredCaseTypes"
            :key="case_type.id"
            :data-testid="`item-${case_type.id}`"
            @click="selectOption(case_type)"
          >
            <a
              href="#"
              rel="nofollow"
              :data-id="case_type.id"
              :class="[
                'casetype-selector__item',
                `casetype-selector__item--ctui-${caseTypeUiTest}`,
                {
                  'casetype-selector__item--selected': isSelected(case_type),
                },
              ]"
              @click.prevent
            >
              <img
                class="casetype-selector__image"
                :src="convertImagekit(case_type.image_url, 500)"
                :alt="case_type.name"
              />
              <div
                :class="[
                  'casetype-selector__label',
                  {
                    'casetype-selector__label--outofstock': !isInStock(
                      case_type
                    ),
                  },
                ]"
              >
                <p
                  v-if="['b', 'c'].includes(caseTypeUiTest)"
                  class="casetype-selector__label-title"
                  :style="caseTypeNameFontStyle(case_type.name)"
                >
                  {{ namePreview(case_type) }}
                </p>
                <p
                  v-if="caseTypeUiTest === 'c'"
                  class="casetype-selection__label-resume"
                >
                  {{ caseTypeDetailsParser(case_type.details, 'resume') }}
                </p>
                <div
                  v-if="caseTypeUiTest === 'c'"
                  class="casetype-selection__label-colors"
                >
                  <div
                    style="background: pink"
                    class="casetype-selection__label-color"
                  ></div>
                  <div
                    style="background: dodgerblue"
                    class="casetype-selection__label-color"
                  ></div>
                  <div
                    style="background: green"
                    class="casetype-selection__label-color"
                  ></div>
                  <div
                    style="background: yellow"
                    class="casetype-selection__label-color"
                  ></div>
                </div>
                <div
                  v-if="
                    isInStock(case_type) &&
                    ($isGlobalStore || ['b', 'c'].includes(caseTypeUiTest))
                  "
                  class="casetype-selector__label-price"
                >
                  {{ formatPrice(case_type.price) }}
                </div>
                <template v-if="isPreSale">
                  {{ $t('product_form.coming_soon') }}
                </template>
                <template v-else-if="!isInStock(case_type)">
                  {{ $t('product_form.sold_out') }}
                </template>
              </div>
            </a>
          </li>
        </ul>
        <div
          v-if="
            caseTypeUiTest === 'c' &&
            (Math.abs(translateX) !== maximumTranslate || translateX === 0)
          "
          class="casetype-selector__list-clamp"
        ></div>

        <div v-if="caseTypeUiTest === 'c'" class="casetype-selector__list-nav">
          <button
            v-show="translateX != 0"
            class="casetype-selector__list-nav-item casetype-selector__list-nav-item--left"
            @click="navGallery(1)"
          >
            <ArrowLeft class="casetype-selector__arrow" />
          </button>
          <button
            class="casetype-selector__list-nav-item casetype-selector__list-nav-item--right"
            @click="navGallery(-1)"
          >
            <ArrowRight class="casetype-selector__arrow" />
          </button>
        </div>
      </div>
    </div>

    <case-type-group-selector
      v-if="currentOption"
      :device-id="deviceId"
      :variant-id="variantId"
      :product-id="productId"
      :case-types="currentOption.case_types"
      :product-stock="productStock"
      :is-pre-sale="isPreSale"
      :case-type-default-id="
        selectedCaseTypeId || currentOption.case_type_default_id
      "
      auto-select
      :is-crossell="isCrossell"
      @updateCaseTypeId="updateCaseTypeId"
    />
  </div>
</template>

<script>
/* eslint-disable camelcase */

import convertImagekit from '@/utils/convertImagekit'
import CaseTypeGroupSelector from '~/components/product/form/case-type-group-selector/CaseTypeGroupSelector.vue'
import InfoIcon from '~/components/icons/info/Info.vue'
import VButton from '~/components/v-button/VButton.vue'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'

import bodyOverflowManager from '~/mixins/bodyOverflowManager'
import priceable from '~/mixins/priceable'
import caseTypeSelectable from '~/mixins/caseTypeSelectable'
import appendUrlParam from '~/utils/appendUrlParam'
import Modal from '~/components/Modal'
import scrollingNavigator from '~/mixins/scrolling-navigator'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  name: 'CaseTypeSelector',
  components: {
    CaseTypeGroupSelector,
    InfoIcon,
    Modal,
    VButton,
    ArrowLeft,
    ArrowRight,
  },
  mixins: [
    priceable,
    caseTypeSelectable,
    scrollingNavigator,
    pushDataLayer,
    bodyOverflowManager,
  ],
  props: {
    lineItemEditor: {
      type: Boolean,
      default: false,
    },
    deviceId: {
      type: Number,
      default: null,
    },
    productId: {
      type: Number,
      default: null,
    },
    variantId: {
      type: Number,
      default: null,
    },
    selectedCaseDeviceId: {
      type: Number,
      default: null,
    },
    permittedCaseTypeIds: {
      type: Array,
      default: () => [],
    },
    isCrossell: {
      type: Boolean,
      default: false,
    },
    customplaceItem: {
      type: Object,
      default: null,
    },
    productStock: {
      type: Object,
      required: true,
    },
    checkboxId: {
      type: Number,
      default: null,
    },
    isPreSale: {
      type: Boolean,
      default: false,
    },
  },
  async fetch() {
    await this.updateData()
  },
  data() {
    return {
      baseWidth: 175,
      listClassName: 'casetype-selector__list',
      caseTypeGroups: [],
      caseTypeGroupsWithPrices: [],
      inputValue: null,
      selectedCaseTypeId: null,
      selectedCaseTypeGroupId: null,
      caseTypeInfoModal: false,
      currentCaseTypeDetails: null,
    }
  },
  computed: {
    isMobileFixedMockup() {
      return this.$device.isMobile && this.$route.name === 'slug-p-case_device'
    },
    isSlimAirOnIphone13() {
      return [777].includes(this.deviceId)
    },
    caseTypeUiTest() {
      const ctUiDefault = 'b'
      const ctui =
        this.$route.query.ctui ||
        sessionStorage?.getItem?.('ctui') ||
        ctUiDefault
      return ['a', 'b', 'c'].includes(ctui) ? ctui : 'a'
    },
    showCaseTypeShowMore() {
      const active = this.$isBrStore
      const detailsCtgs = this.caseTypeGroupsWithPrices.filter(
        (ctg) => !!ctg.details
      )
      return (
        detailsCtgs.length === this.caseTypeGroupsWithPrices.length && active
      )
    },
    caseTypeOptions() {
      return this.currentOption?.case_types || []
    },
    selectedName() {
      return this.currentOption && this.currentOption.name
    },
    currentOption() {
      return this.caseTypeGroups?.find((opt) => {
        return (
          opt.id === this.inputValue ||
          opt?.case_types?.map(this.getOptionValue)?.includes(this.inputValue)
        )
      })
    },
    isDeluxeRule() {
      return false // this.$isGlobalStore // && [505, 506, 507, 133].includes(this.deviceId)
    },
    isEcoRule() {
      return false // this.$isGlobalStore && this.$route.path.match('iphone-12-pro-max')
    },
    isSoftFlexible() {
      return false // this.$isGlobalStore
    },
    filteredCaseTypes() {
      const inStockItems = this.getInStockItems()
      const selectedCaseDevice = this.getSelectedCaseDevice()

      if (selectedCaseDevice && !this.isInStock(selectedCaseDevice)) {
        inStockItems.push(selectedCaseDevice)
      }

      return inStockItems
    },
    hasMultipleFilteredCaseTypes() {
      return this.filteredCaseTypes.length > 1
    },
  },
  watch: {
    async deviceId() {
      await this.updateData()
    },
    inputValue(_newValue, oldValue) {
      if (this.isCrossell) return

      if (oldValue) this.$store.dispatch('product/setRestartingEngine', true)
    },
  },
  methods: {
    convertImagekit,
    namePreview(case_type) {
      const ct = case_type.case_types.find(
        (ct) => Number(ct.id) === Number(case_type.id)
      )

      if (ct) return ct.name || ct.group_name

      return case_type.name
    },
    caseTypeNameFontStyle(name) {
      if (name.length <= 22) return ''

      const size = name.length > 22 && name.length < 26 ? 13 : 11
      return `font-size: ${size}px`
    },
    caseTypeDetailsParser(details, attr = 'resume') {
      if (!details) return null

      const str = details
      const regex = new RegExp(`<ddl-${attr}>(.*?)</ddl-${attr}>`, 's')
      const match = str.match(regex)
      const result = match?.[1]

      if (['icons', 'attributes'].includes(attr)) {
        try {
          return result ? JSON.parse(result) : null
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('caseTypeDetailsParser', attr, err)
          return null
        }
      } else {
        return result
      }
    },
    openShowMore() {
      this.caseTypeInfoModal = true
      this.defaultCaseTypeSelectedBeforeShowMore = this.inputValue
      this.disableBodyScroll()

      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'interactWithPage',
        eventAction: 'clickOnButton',
        eventValue: 'casetypes_knowmore',
      })
    },
    closeShowMore(backToOldCaseType = false) {
      this.caseTypeInfoModal = false
      this.enableBodyScroll()
      if (!backToOldCaseType)
        this.inputValue = this.defaultCaseTypeSelectedBeforeShowMore
    },
    updateCaseTypeId(ctId) {
      this.$emit('updateCaseTypeId', ctId)
    },
    getOptionValue(option) {
      if (this.optionValueKey === '@self') return option
      if (option instanceof Object) return option?.[this.optionValueKey]

      return option ?? ''
    },
    async updateData() {
      if (this.deviceId) {
        let response

        if (this.customplaceItem) {
          const customplaceParams = {
            product_id: this.productId,
            ...this.$store.getters.storeInfo,
            ...this.customplaceItem.line_item,
          }
          response = await this.$axios.$get(
            appendUrlParam(`custom_place/case_types`, customplaceParams)
          )
        } else {
          response = await this.$axios.$get('/products/case_types', {
            params: {
              product_id: this.productId,
              ...this.$store.getters.storeInfo,
              case_type_ids: this.permittedCaseTypeIds.join(','),
            },
          })
        }

        const deviceData = response.devices.map((device) => ({
          id: device.id,
          code: device.code,
          related_devices_description: device.related_devices_description,
        }))

        this.$store.dispatch('devices/updateDeviceData', deviceData)

        const selectedCaseTypeGroup = response.case_type_groups?.find((ctg) => {
          const caseType = ctg.case_types?.find((ct) =>
            ct?.devices.find(
              (dv) => dv?.case_device_id === this.selectedCaseDeviceId
            )
          )

          this.selectedCaseTypeId = caseType?.id

          return !!caseType
        })

        this.selectedCaseTypeGroupId =
          selectedCaseTypeGroup?.case_types?.[0]?.id

        this.caseTypeGroups = response.case_type_groups.map((ctg) => {
          return {
            ...ctg,
            id: ctg.case_types[0].id,
            details: ctg.case_types.find((ct) => !!ct.details)?.details,
          }
        })
        await this.fetchCurrentPrices()
        this.selectDefaultOption()
      }
    },
    getOptionDevice(option) {
      return (
        option.case_types.find(
          (ct) => ct.id === Number(option.case_type_default_id)
        ) || option.case_types[0]
      ).devices.find((dv) => dv.device_id === this.deviceId)
    },
    async fetchCurrentPrices() {
      try {
        let options = this.caseTypeGroups.filter((ctg) =>
          ctg.case_types.find((ct) =>
            ct.devices.find((dv) => dv.device_id === this.deviceId)
          )
        )

        options = options.map((opt) => {
          opt.case_types = opt.case_types.filter((ct) =>
            ct.devices.find((dv) => dv.device_id === this.deviceId)
          )
          return opt
        })

        let optionsPrices = []
        const caseDeviceIds = options.map(
          (co) => this.getOptionDevice(co).case_device_id
        )

        if (
          options.length &&
          caseDeviceIds.length &&
          caseDeviceIds.filter((cd) => !!cd).length
        ) {
          const newOptionsPrices = await this.$axios.$get('/products/price', {
            params: {
              ...this.$store.getters.storeInfo,
              variant_id: this.variantId,
              case_device_ids: caseDeviceIds.join(','),
              product_id: this.productId,
              checkbox_id: this.checkboxId,
            },
          })

          options.map((co) => {
            const caseDevice = this.getOptionDevice(co)

            const {
              price,
              old_price,
              promotion,
              case_device_id,
            } = newOptionsPrices.find(
              (nop) => nop.case_device_id === caseDevice.case_device_id
            )

            optionsPrices.push({
              ...co,
              case_device_id,
              price,
              old_price,
              promotion,
            })
          })
        }

        let rest = optionsPrices
          .filter(
            (op) =>
              !op.case_types.find((ct) => ct.code.match('standard')) &&
              !(
                op.case_types.find((ct) => ct.code.match('slim')) ||
                op.name?.match('Impact Slim')
              )
          )
          ?.sort((a, b) => a.id - b.id)
          ?.sort((a, b) => Number(a.price) - Number(b.price))

        const sortByCaseTypeName = (caseTypeName) => {
          rest = rest.filter((op) => !op.name?.match(caseTypeName))
          return this.sortByIdAndPrices(
            optionsPrices.filter((op) => op.name?.match(caseTypeName))
          )
        }

        let deluxes = []
        let slimair = []

        if (this.isDeluxeRule) {
          deluxes = sortByCaseTypeName('Deluxe')
        }

        if (this.isSlimAirOnIphone13) {
          slimair = sortByCaseTypeName('Slim Air')
        }

        let ecos = []
        if (this.isEcoRule) {
          ecos = sortByCaseTypeName('ECO')
        }

        let softs = []
        if (this.isSoftFlexible) {
          softs = sortByCaseTypeName('Soft')
        }

        const standards = this.sortByIdAndPrices(
          optionsPrices.filter((op) =>
            op.case_types.find((ct) => ct.code.match('standard'))
          )
        )

        let impactslims = this.sortByIdAndPrices(
          optionsPrices.filter(
            (op) =>
              op.case_types.find((ct) => ct.code.match('slim')) ||
              op.name?.match('Impact Slim')
          )
        )

        const sortByCaseTypeCode = (caseTypeCode) => {
          rest = rest.filter(
            (op) => !op.case_types.find((ct) => ct.code.match(caseTypeCode))
          )
          return this.sortByIdAndPrices(
            optionsPrices.filter((op) =>
              op.case_types.find((ct) => ct.code.match(caseTypeCode))
            )
          )
        }

        let leathers = []
        let magsafes = []

        if (this.$store.state.isUsStore) {
          if (this.$store.state.isUsStore) {
            leathers = sortByCaseTypeCode('leather')
          }

          if (this.$store.state.isUsStore) {
            magsafes = sortByCaseTypeCode('magsafe')
          }

          impactslims = impactslims.filter(
            (rt) => !rt.case_types.find((ct) => ct.code.match('magsafe'))
          )
        }

        optionsPrices = [
          ...slimair,
          ...softs,
          ...ecos,
          ...deluxes,
          ...standards,
          ...impactslims,
          ...rest,
          ...magsafes,
          ...leathers,
        ].filter((v, i, a) => a.indexOf(v) === i)

        const withStock = optionsPrices.filter((op) => this.isInStock(op))
        const withoutStock = optionsPrices.filter((op) => !this.isInStock(op))
        optionsPrices = [withStock, withoutStock].flat()

        this.caseTypeGroupsWithPrices = optionsPrices
      } catch (err) {
        this.$displayTopMessage(this.$t('action_error'))
        this.$sentry.captureException(err.response || err)
      }
    },
    sortByIdAndPrices(options) {
      return options
        ?.sort((a, b) => a.id - b.id)
        ?.sort((a, b) => Number(a.price) - Number(b.price))
    },
    selectOption({ price, id, old_price: oldPrice, details, name }) {
      if (!price) return

      this.currentCaseTypeDetails = details
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'interactWithPage',
        eventAction: 'caseTypeClick',
        eventValue: {
          case_type: name,
          price,
        },
      })

      if (price || oldPrice) {
        if (this.isCrossell) {
          this.$emit('updatePrice', {
            price,
            oldPrice,
          })
        } else {
          this.$store.dispatch('product/setCurrentPrice', price)
          this.$store.dispatch('product/setOldPrice', oldPrice)
        }
      }

      this.inputValue = id
    },
    selectDefaultOption() {
      const ctgToSelect =
        this.caseTypeGroupsWithPrices.find(
          (ctg) => ctg.id === this.selectedCaseTypeGroupId
        ) || this.caseTypeGroupsWithPrices?.[0]
      this.selectOption(ctgToSelect)
    },
    isSelected(option) {
      return this.currentOption?.id === option.id
    },
    getInStockItems() {
      return this.caseTypeGroupsWithPrices.filter((caseType) =>
        this.isInStock(caseType)
      )
    },
    getSelectedCaseDevice() {
      return this.caseTypeGroupsWithPrices.find(
        (caseType) => caseType.id === this.selectedCaseTypeId
      )
    },
  },
}
</script>

<style lang="scss" scoped>
$color-white: white;
$color-transparent-white: rgba(253, 247, 250, 0);
$color-light-gray-alpha-50: rgba(229, 235, 235, 0.5);
$color-light-gray: rgba(229, 235, 235, 1);
$color-gray: #8f8f8f;
$color-gray-alpha-21: rgba(143, 143, 143, 0.21);
$color-gray-text: #929296;
$color-dark-gray: #474747;
$color-light-gray2: #e3e6e8;
$color-black-alpha-70: rgba(0, 0, 0, 0.7);
$color-light-gray-border: #b2b2b6;
$color-off-white: #fcfdf7;

.casetype-selector__container {
  overflow: hidden;
  padding: 10px;
  margin: -10px;

  .casetype-selector__list-clamp {
    background: linear-gradient(
      270deg,
      $color-white,
      $color-transparent-white 100%
    );
    width: 50px;
    position: absolute;
    height: 100%;
    right: -15px;
    bottom: 0;
  }
}

.casetype-selector__list-nav {
  display: block;
  width: 100%;

  .casetype-selector__arrow {
    width: 20px;
    fill: $v4_color_primary;
    transition: all 0.2s ease-in-out;
  }

  .casetype-selector__list-nav-item {
    position: absolute;
    top: 65%;
    margin-top: -54px;
    width: 40px;
    height: 40px;
    line-height: 45px;
    z-index: 5;
    text-align: center;
    border-radius: 50%;
    border: 0;
    background-color: $color-light-gray-alpha-50;
    cursor: pointer;

    &:focus {
      outline: 0;
    }
    &:hover {
      background-color: $color-light-gray;
    }

    &--left {
      left: -50px;
    }
    &--right {
      right: -50px;
    }
  }
}

.casetype-selector__attributes {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 1;
  background: $v4_color_primary_lighter;
  padding: 10px;
  border-radius: 3px;

  .casetype-selector__attributes-fixed-title {
    color: $color-white;
    background: $v4_color_primary;
    padding: 3px 5px;
    border-radius: 3px;
  }

  li {
    flex: 1;
  }

  &--mobile {
    top: calc(100vw - 5px);
  }

  &-title {
    display: flex;
    color: $v4_color_primary;
    font-size: 13px;
    align-items: center;

    span {
      color: $color-gray;
      margin-right: 5px;
    }
  }

  &-progress {
    width: 100%;
    background: $color-gray-alpha-21;
    height: 5px;
    border-radius: 5px;

    > div {
      background: $v4_color_primary;
      height: 100%;
      border-radius: 5px;
    }
  }
}

.casetype-selector {
  margin: 10px 0 30px;

  .casetype-selector__selected {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;

    b {
      margin-left: 5px;
    }

    .casetype-selector__hint {
      font-size: 11px;
      text-transform: uppercase;
      color: $color-gray-text;
      font-weight: normal;
    }
  }

  .casetype-selector__info {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;

    small {
      margin-left: 5px;
    }
  }

  .casetype-info {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    gap: 10px;
    justify-content: center;

    &__description {
      margin-top: 20px;
    }

    &__name {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 5px;
      background: $color-black-alpha-70;
      text-align: center;
      font-weight: bold;
      overflow: hidden;
      color: $color-white;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    &__item {
      width: 130px;
      height: 140px;
      border: 1px solid $v4_color_line_lighter;
      box-shadow: 0 0 1px 0 $color-white;
      transition: border-color 150ms ease-in-out;
      border-radius: 2px;
      position: relative;

      &--selected {
        border-color: $v4_color_primary;
      }

      a,
      img {
        width: 125px;
        height: 125px;
        border-radius: 2px;
        top: 0;
        left: 0;
        position: absolute;
      }
    }

    @media (max-width: $v4_tablet) {
      &__name {
        font-size: 12px;
      }

      &__item {
        width: 100px;
        height: 120px;

        a,
        img {
          width: 95px;
          height: 95px;
        }
      }
    }
  }

  .casetype-selector__list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
  }

  .casetype-selector__item,
  .casetype-selector__image {
    border-radius: 3px;
  }
  .casetype-selector__item {
    display: block;
    border: 0.8px solid $color-gray;
    box-shadow: 0 0 1px 0 $color-white;
    position: relative;
    padding-top: 100%;

    &:hover {
      border-color: $color-light-gray-border;
    }

    &.casetype-selector__item--selected {
      border-color: $v4_color_primary;

      p {
        color: $v4_color_primary;
      }

      .casetype-selector__label {
        &-price {
          background-color: $v4_color_primary;
        }
        &.casetype-selector__label--outofstock {
          background-color: $v4_color_text;
        }
      }
    }
  }
  .casetype-selector__image {
    width: 100%;
    position: absolute;
    top: 0;
  }
  .casetype-selector__label {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: $color-dark-gray;
    font-weight: bold;
    font-size: 12px;
    transition: all 150ms ease-in-out;

    &-price {
      background-color: $color-dark-gray;
      text-transform: uppercase;
      color: $color-white;
      width: 100%;
      border-radius: 2px;
      font-size: 16px;
    }

    &-title {
      font-size: 14px;
      margin: 0px;
      margin-bottom: 2px;
      padding: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }

    &.casetype-selector__label--outofstock {
      background-color: $color-light-gray2;
      color: $color-gray;
    }
  }
}

.casetype-selector__item--ctui-b {
  padding-bottom: 50px;
}

.casetype-selector__list--ctui-b {
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

@media (max-width: 1200px) {
  .casetype-selector__list--ctui-b {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}

.casetype-selector__container--ctui-c {
  margin-left: -15px;
  padding-left: 15px;
  margin-right: -15px;
  padding-right: 15px;
}

.casetype-selector__attributes--ctui-c {
  margin-bottom: 0px;
}

.casetype-selector__list--ctui-c {
  display: flex !important;
  scroll-snap-type: x mandatory;
  background: $color-off-white;
  margin: 0 auto;
  width: 105%;
  margin-left: -15px;
  padding-left: 15px;
  padding-top: 20px;
  transition: transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1) 0s;

  @media (max-width: $v4_desktop) {
    overflow: auto;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  & {
    -ms-overflow-style: none;
  }

  overflow: -moz-scrollbars-none;

  > li {
    flex-shrink: 0;
    scroll-snap-align: center;
    scroll-snap-stop: always;
    background: $color-white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 170px;

    a {
      width: 100%;
      padding-bottom: 140px;

      .casetype-selection__label-resume {
        margin: 0;
        margin-bottom: 2px;
        padding: 2px;
        font-weight: 500;
      }

      .casetype-selection__label-colors {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 10px 0px;
        margin-top: 5px;
        gap: 5px;

        > div {
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
